import { AppBar, IconButton, Toolbar } from '@material-ui/core/'
import { Menu } from '@material-ui/icons'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import logo from '../../assets/img/butterfly.png'
import { SIDE_NAV_OPEN } from '../../constants/navigationConstants'
import NavMenu from './NavMenu'

const HeaderBar = styled(AppBar)`
  border-style: solid;
  border-image: var(--color-gradient);
  border-image-slice: 1;
  border-width: 2px;
  border-top: none;
  border-left: none;
  border-right: none;
  z-index: 1299;

  &.MuiAppBar-root {
    padding: 8px 70px;
    background: black;

    .MuiToolbar-root {
      display: flex;
      justify-content: space-between;
    }

    .branding {
      font-size: 1.5rem;
      color: white;

      img {
        width: 50px;
      }

      &:hover {
        text-decoration: none !important;
      }
    }

    strong {
      font-weight: 700;
    }

    .btn-gradient {
      margin: 0 30px;
    }
  }

  a {
    color: var(--color-secondary);
  }

  &.light {
    background: white;

    .branding {
      color: black;
    }
  }

  &.dark {
    button.MuiButtonBase-root.btn-gradient .MuiButton-label {
      color: white;
      background: black;
    }

    button.MuiButtonBase-root.MuiIconButton-root svg {
      color: white;
    }
  }

  .name-dot {
    height: 22px;
    width: 22px;
    margin-right: 5px;
  }

  @media only screen and (max-width: 1400px) {
    &.MuiAppBar-root {
      padding: 8px 6px;
    }
  }

  @media only screen and (max-width: 960px) {
    .name-dot {
      display: flex;
      font-size: 12px;
      width: 25px;
      height: 25px;
      justify-content: center;
    }

    .full-name {
      display: none;
    }
  }

  @media only screen and (max-width: 767px) {
    .MuiToolbar-root {
      padding: 0;
    }
  }
`

const Header = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const isHomePage = location.pathname === '/'

  const { userInfo } = useSelector((state: RootStateOrAny) => state.userLogin)

  const showAEPortalText =
    isHomePage || !userInfo ? false : userInfo.isAdmin ? true : false

  return (
    <HeaderBar
      position="relative"
      className={`header ${isHomePage ? 'dark' : 'light'}`}
    >
      <Toolbar>
        <div className="flex align-center">
          {userInfo && (
            <IconButton
              className="m-r-16 m-l-8 show-767"
              onClick={() => dispatch({ type: SIDE_NAV_OPEN })}
            >
              <Menu />
            </IconButton>
          )}

          <Link className="branding" to="/">
            <div className="flex m-t-5">
              <img
                src={logo}
                className="logo"
                alt="Hexagon Logo"
                style={{ marginTop: '-7px' }}
              />
              <strong className="uppercase">Hexagon</strong>
            </div>
          </Link>
        </div>

        {showAEPortalText && (
          <div className="black-text strong hide-767">AE Portal</div>
        )}

        <div className="menu">
          <NavMenu />
        </div>
      </Toolbar>
    </HeaderBar>
  )
}

export default Header
